import {
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Divider,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import DownIcon from "@material-ui/icons/KeyboardArrowDown";
import PersonOutlineOutlined from "@material-ui/icons/PersonOutlineOutlined";
import * as registry from "@qpr/client-api-registry";
import { UserInfo, useAuth, useCurrentTenant } from "@qpr/client-library";
import clsx from "clsx";
import { t } from "i18next";
import { System } from "qpr-base/configuration/index";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { getModelIdForYear } from "qpr-base/context/modelsByYear";
import useCurrentUser from "qpr-base/context/UserContext";
import { shouldHideCeoRestrictedNav } from "utils/navItemRoleFilters";
import { clearElementCache } from "qpr-base/querybuilder/ElementCache";
import HorizontalMenu from "qpr-base/ui/HorizontalMenuView";
import AppBar from "qpr-base/viewcomponents/AppBar/AppBar";
import ApplicationToolBar from "qpr-base/viewcomponents/ApplicationToolBar/ApplicationToolBar";
import Flex from "qpr-base/viewcomponents/Flex/Flex";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React, { useEffect, useRef } from "react";
import { useQueryClient } from "react-query";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import useNotificationBell from "../../backend/hooks/workflows/useNotificationBell";
import { ICardElementWithChildren } from "backend/model/model";
import useLink from "qpr-base/hooks/useLink";
import HomeIcon from "../../design/components/icons/HomeIcon";
import { buildKpisFilterStorageKey, persistKpisFilters } from "pages/kpis/useKpisFilters";
const styles = makeThemedStyles("AppBar.Icons", (theme) => ({
  iconButton: {
    width: "32px",
    height: "32px",
    marginLeft: "15px",
    marginRight: "15px",
    color: "#111111",
    "& img": {
      filter: "brightness(0)",
    },
    "& .MuiSvgIcon-root": {
      width: "28px",
      height: "28px",
      fontSize: "28px",
    },
  },
  supportButton: {
    marginLeft: "12px",
    marginRight: "12px",
    padding: "8px 14px",
    borderRadius: "999px",
    border: "1px solid rgba(0, 0, 0, 0.18)",
    background: "rgba(0, 0, 0, 0.03)",
    color: "#111111",
    fontFamily: '"Dubai", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    fontWeight: 600,
    fontSize: "1.15em",
    textTransform: "none",
    whiteSpace: "nowrap",
    letterSpacing: "0.2px",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.06)",
      borderColor: "rgba(0, 0, 0, 0.32)",
    },
  },
  supportDialogPaper: {
    borderRadius: "14px",
    overflow: "hidden",
  },
  supportDialogTitle: {
    background: "linear-gradient(135deg, rgba(16, 73, 80, 1), rgba(15, 45, 58, 1))",
    color: "#ffffff",
    padding: "20px 22px",
  },
  supportDialogTitleText: {
    fontSize: "1.55em",
    fontWeight: 900,
    letterSpacing: "0.2px",
    lineHeight: 1.2,
  },
  supportDialogSubtitle: {
    marginTop: "6px",
    opacity: 0.9,
    fontSize: "1.05em",
    lineHeight: 1.5,
  },
  supportDialogContent: {
    padding: "18px 22px 8px 22px",
  },
  supportInfoCard: {
    borderRadius: "12px",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    background: "rgba(245, 245, 246, 0.55)",
  },
  supportInfoCardContent: {
    padding: "16px 16px 14px 16px",
  },
  supportLabel: {
    fontSize: "1.05em",
    fontWeight: 800,
    color: "rgba(76, 81, 87, 1)",
    marginBottom: "6px",
  },
  supportEmailLink: {
    color: "rgb(6, 156, 240)",
    fontSize: "1.15em",
    fontWeight: 800,
    textDecoration: "none",
    wordBreak: "break-word",
  },
  supportHint: {
    marginTop: "10px",
    fontSize: "1.05em",
    color: "rgba(76, 81, 87, 0.85)",
    lineHeight: 1.6,
  },
  supportTeamsButton: {
    marginTop: "8px",
    borderRadius: "10px",
    fontWeight: 800,
    fontSize: "1.05em",
    textTransform: "none",
    padding: "10px 14px",
    alignSelf: "flex-start",
  },
  supportTeamsRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "20px",
    marginTop: "12px",
    alignItems: "flex-start",
  },
  supportTeamsColumn: {
    flex: "1 1 220px",
    minWidth: "220px",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  supportContactName: {
    fontSize: "1.08em",
    fontWeight: 800,
    color: "rgba(76, 81, 87, 1)",
    marginBottom: "4px",
    textAlign: "left",
    width: "100%",
  },
  avatarButton: {
    width: "20px",
    height: "20px",
    marginLeft: "35px",
    marginRight: "35px",
    color: "#111111",
  },
  avatarIcon: {
    width: "38px",
    height: "38px",
    color: "#111111",
    backgroundColor: "rgb(220, 222, 224)",
  },
  appBarLeftSide: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    maxWidth: "70%",
    overflow: "hidden",
  },
  planContainer: {
    width: "15em",
    height: "4.457em",
    backgroundColor: "rgba(241, 245, 249, 1)",
    borderRadius: "2.285em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0px 1.14em 0px 1.14em",
    transition: "left 0.5s",
    border: "1px solid rgba(15, 23, 42, 0.08)",
  },
  planText: {
    fontSize: "1.37em",
    lineHeight: "20.26px",
    color: "#111111",
    fontFamily: '"Dubai", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    fontWeight: 600,
  },
  toToggleMove: {
    left: "450px",
  },
}));
const userUserMenuStyles = makeThemedStyles("AppBar.UserMenu", (theme) => ({
  card: {
    zIndex: 999999999,
    fontSize: "1.142em",
    width: "27.3em",
    display: "flex",
    flexDirection: "column",
    borderRadius: "1em",
    position: "absolute",
    top: "5.9em",
    overflow: "visible",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "-4px",
      right: "1.551em",
      width: 0,
      height: 0,
      borderLeft: "4px solid transparent",
      borderRight: "4px solid transparent",
      borderBottom: "4px solid #fff",
    },
  },
  cardRTL: {
    left: "368px",
    "&::after": {
      right: "unset",
      left: "1.551em",
    },
  },
  actions: {
    height: "4em",
    marginTop: "auto",
    background: "rgba(196, 196, 196, 0.14)",
    padding: 0,
  },
  logout: {
    color: "rgb(14, 37, 106)",
    height: "100%",
    width: "100%",
    letterSpacing: "1.3px",
    fontSize: "1.2em",
    fontWeight: 700,
    padding: 0,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "0px",
  },
  avatar: {
    height: "2.56em",
    width: "2.56em",
  },
  avatarIcon: {
    width: "38px",
    height: "38px",
    color: "white",
    backgroundColor: "rgb(183, 186, 187)",
  },
  details: {
    margin: "0 1.2em",
  },
  name: {
    fontWeight: 500,
    fontSize: "1.6em",
    lineHeight: "1.25em",
    letterSpacing: "0.05px",
    color: "rgba(76, 81, 87, 1)",
  },
  email: {
    marginTop: "0.214em",
    letterSpacing: "0.05625px",
    fontSize: "1.4em",
    lineHeight: "1.428em",
    color: "rgb(6, 156, 240)",
  },
  section: {
    display: "flex",
    alignItems: "center",
    padding: "15px",
  },
  registerIcon: {
    width: "8.53px",
    height: "12.8px",
  },
  bordersec: {
    border: "1px solid rgba(0, 0, 0, 0.05)",
    justifyContent: "center",
    cursor: "pointer",
    width: "100%",
  },
}));
const notificationDropdownStyles = makeThemedStyles(
  "AppBar.NotificationDropdown",
  (theme) => ({
    card: {
      zIndex: 999999999,
      fontSize: "1.142em",
      width: "35em",
      maxHeight: "50vh",
      display: "flex",
      flexDirection: "column",
      borderRadius: "1em",
      position: "absolute",
      top: "5.9em",
      overflow: "hidden",
      "&::after": {
        content: '""',
        position: "absolute",
        top: "-4px",
        right: "1.551em",
        width: 0,
        height: 0,
        borderLeft: "4px solid transparent",
        borderRight: "4px solid transparent",
        borderBottom: "4px solid #fff",
      },
    },
    cardRTL: {
      left: "368px",
      "&::after": {
        right: "unset",
        left: "1.551em",
      },
    },
    content: {
      display: "flex",
      flexDirection: "column",
      padding: "0px",
      maxHeight: "45vh",
      overflowY: "auto",
    },
    header: {
      padding: "1.2em",
      borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    },
    title: {
      fontWeight: 700,
      fontSize: "1.6em",
      lineHeight: "1.25em",
      letterSpacing: "0.05px",
      color: "rgba(76, 81, 87, 1)",
    },
    taskItem: {
      padding: "1em 1.2em",
      cursor: "pointer",
      borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.02)",
      },
      "&:last-child": {
        borderBottom: "none",
      },
    },
    taskName: {
      fontWeight: 500,
      fontSize: "1.4em",
      lineHeight: "1.25em",
      color: "rgba(76, 81, 87, 1)",
      marginBottom: "0.3em",
    },
    taskDetails: {
      fontSize: "1.2em",
      color: "rgba(76, 81, 87, 0.7)",
      lineHeight: "1.4em",
    },
    emptyState: {
      padding: "2em 1.2em",
      textAlign: "center",
      color: "rgba(76, 81, 87, 0.5)",
      fontSize: "1.4em",
    },
    viewAll: {
      padding: "1em 1.2em",
      borderTop: "1px solid rgba(0, 0, 0, 0.1)",
      textAlign: "center",
      cursor: "pointer",
      backgroundColor: "rgba(196, 196, 196, 0.14)",
      "&:hover": {
        backgroundColor: "rgba(196, 196, 196, 0.2)",
      },
    },
    viewAllText: {
      fontWeight: 700,
      fontSize: "1.2em",
      letterSpacing: "1.3px",
      color: "rgb(14, 37, 106)",
    },
  })
);
interface Tenant {
  symbol: string;
  metricsModelId: string;
  redirectUrl: string;
  landingUrl?: string;
  authMethod?: string;
  menuType?: string;
}
type IUserMenuCard = {
  logout: () => void;
  onClose: () => void;
  tenant: Tenant;
  user: UserInfo;
  parentRef: HTMLElement | null;
};
function UserMenuCard(props: IUserMenuCard) {
  const { logout, user, onClose, parentRef } = props;
  const classes = userUserMenuStyles();
  const { rtl, model } = useAppContext();
  const cardRef = useRef<HTMLElement>(null);
  const history = useHistory();
  const tenant = useCurrentTenant();
  const MobileIconOutlined = registry.getSvg("MobileIconOutlined");
  const resolvedFullName =
    (user as any)?.fullname || (user as any)?.fullName || user?.username || "";
  const resolvedEmail = (user as any)?.email || "";
  useEffect(() => {
    if (parentRef && cardRef.current) {
      const { left } = parentRef.getBoundingClientRect();
      cardRef.current.style.left = `${left - (rtl ? -9 : 88)}px`;
    }
  }, [parentRef, rtl]);
  useEffect(() => {
    function handler(e: any) {
      if (!parentRef?.contains(e.target)) {
        onClose();
      }
    }
    if (cardRef.current) {
      document.addEventListener("click", handler);
    }
    return () => {
      document.removeEventListener("click", handler);
    };
  }, [cardRef, parentRef, onClose]);
  return (
    <Card className={clsx(classes.card, rtl && classes.cardRTL)} ref={cardRef}>
      <CardContent className={classes.content}>
        <div className={classes.section}>
          <Avatar className={classes.avatarIcon}>
            <PersonOutlineOutlined fontSize="large" />
          </Avatar>
          <div className={classes.details}>
            <Typography className={classes.name}>{resolvedFullName}</Typography>
            {resolvedEmail && (
              <Typography className={classes.email}>{resolvedEmail}</Typography>
            )}
          </div>
        </div>
        {System.flags.mobileAppRegistration ? (
          <div
            role="button"
            tabIndex={0}
            onClick={() => {
              history.push(`/${tenant.symbol}/${model}/register/`);
              onClose();
            }}
            onKeyDown={() => history.push(`/tec/${model}/register/`)}
            className={clsx(classes.section, classes.bordersec)}
          >
            <MobileIconOutlined className={classes.registerIcon} />
            <div className={classes.details}>
              <Typography className={classes.name}>
                {t("Mobile Application Registration")}
              </Typography>
            </div>
          </div>
        ) : null}
      </CardContent>
      {(props.tenant.authMethod === "ums" || props.tenant.authMethod === "saml") && (
        <CardActions className={classes.actions}>
          <Button variant="text" className={classes.logout} onClick={logout}>
            {t("Logout")}
          </Button>
        </CardActions>
      )}
    </Card>
  );
}
type INotificationDropdown = {
  onClose: () => void;
  parentRef: HTMLElement | null;
  onTaskClick: (task: ICardElementWithChildren) => void;
  tasks: ICardElementWithChildren[];
  isLoading: boolean;
};
function NotificationDropdown(props: INotificationDropdown) {
  const { onClose, parentRef, onTaskClick, tasks, isLoading } = props;
  const classes = notificationDropdownStyles();
  const { rtl } = useAppContext();
  const cardRef = useRef<HTMLElement>(null);
  const history = useHistory();
  const ctx = useAppContext();
  const tenant = useCurrentTenant();
  useCurrentUser();

  // Reuse the already-fetched tasks from AppBar to avoid duplicate network calls.
  const filteredTasks = tasks || [];

  useEffect(() => {
    if (parentRef && cardRef.current) {
      const { left } = parentRef.getBoundingClientRect();
      cardRef.current.style.left = `${left - (rtl ? -9 : 88)}px`;
    }
  }, [parentRef, rtl]);

  useEffect(() => {
    function handler(e: any) {
      if (!parentRef?.contains(e.target) && !cardRef.current?.contains(e.target)) {
        onClose();
      }
    }
    if (cardRef.current) {
      document.addEventListener("click", handler);
    }
    return () => {
      document.removeEventListener("click", handler);
    };
  }, [cardRef, parentRef, onClose]);

  const handleViewAll = () => {
    history.push(`/${tenant.symbol}/${ctx.modelId}/mytasks`);
    onClose();
  };

  const handleTaskClick = (task: ICardElementWithChildren) => {
    onTaskClick(task);
    onClose();
  };

  const displayTasks = (filteredTasks || []).slice(0, 5) as ICardElementWithChildren[];

  return (
    <Card className={clsx(classes.card, rtl && classes.cardRTL)} ref={cardRef}>
      <CardContent className={classes.content}>
        <div className={classes.header}>
          <Typography className={classes.title}>
            {t("mytasks.My Tasks")}
          </Typography>
        </div>
        {isLoading ? (
          <div className={classes.emptyState}>{t("Loading...")}</div>
        ) : displayTasks.length === 0 ? (
          <div className={classes.emptyState}>
            {t("mytasks.No tasks available")}
          </div>
        ) : (
          displayTasks.map((task, index) => (
            <div
              key={task.workflowState?.wfInstanceId || index}
              className={classes.taskItem}
              onClick={() => handleTaskClick(task)}
            >
              <Typography className={classes.taskName}>
                {task.workflowState?.measurename || task.name}
              </Typography>
              {task.workflowState?.period && (
                <Typography className={classes.taskDetails}>
                  {task.workflowState.period}
                </Typography>
              )}
            </div>
          ))
        )}
        {displayTasks.length > 0 && (
          <div className={classes.viewAll} onClick={handleViewAll}>
            <Typography className={classes.viewAllText}>
              {t("mytasks.View All Tasks")}
            </Typography>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
const BusinessPortalAppBar = () => {
  const userMenuAnchorEl = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = React.useState(false);
  const ctx = useAppContext();
  const classes = styles();
  const tenant: Tenant = useCurrentTenant();
  const user = useCurrentUser();
  useRouteMatch();
  const { pathname } = useLocation();
  const pathParts = pathname.split("/").filter(Boolean);
  const { logout } = useAuth();
  const queryClient = useQueryClient();
  const history = useHistory();
  /** Tenant root (e.g. /tdf/) has no model segment — skip heavy workflow/mytasks/mea for the bell until user navigates in. */
  const isBareTenantHome =
    pathParts.length === 1 && pathParts[0] === tenant.symbol;
  const profile = user?.profile;
  const meaGroups =
    (profile as { meaGroups?: string[] } | undefined)?.meaGroups ||
    (Array.isArray((user as { groups?: string[] })?.groups)
      ? (user as { groups?: string[] }).groups
      : null);
  /** CEO-only users don't get workflow tasks assigned — hide the notification bell for them. */
  const isCeoOnlyUser = shouldHideCeoRestrictedNav(profile, meaGroups);
  const { hasNotification, notificationCount, filteredTasks, isLoading } = useNotificationBell(
    !isBareTenantHome && !isCeoOnlyUser
  );
  const [isNotificationOpen, setIsNotificationOpen] = React.useState(false);
  const notificationAnchorEl = useRef<HTMLDivElement | null>(null);
  const link = useLink();
  const [isSupportOpen, setIsSupportOpen] = React.useState(false);

  const SUPPORT_EMAIL = "c-aalsaiql@tdf.gov.sa";
  const SUPPORT_EMAIL_CPP = "cpp@tdf.gov.sa";
  const SUPPORT_TEAMS_AHMED_UPN = "c-aalsaiqal@tdf.gov.sa";
  const SUPPORT_TEAMS_ABDULRAHMAN_UPN = "aalajlan@tdf.gov.sa";
  const supportTeamsChatUrl = (upn: string) =>
    `https://teams.microsoft.com/l/chat/0/0?users=${encodeURIComponent(upn)}`;

  // Extract model ID from URL pathname as fallback (for normal users where ctx.modelId might not be set)
  // URL structure: /{tenant}/{modelId}/{page}
  const modelIdFromUrl = pathParts.length >= 2 ? pathParts[1] : null;
  // Keep fallback modelId available for future header behaviors (navigation etc.)
  void modelIdFromUrl;

  // Track if notifications have been viewed in this session (persists until logout)
  const [notificationsViewed, setNotificationsViewed] = React.useState(() => {
    try {
      return sessionStorage.getItem("notificationsViewed") === "true";
    } catch {
      return false;
    }
  });

  // Track previous hasNotification state to detect when new notifications arrive
  const prevHasNotificationRef = React.useRef(hasNotification);

  // Reset viewed state when new notifications arrive (session refresh)
  React.useEffect(() => {
    // If notifications were false and now are true, reset viewed state
    if (!prevHasNotificationRef.current && hasNotification) {
      setNotificationsViewed(false);
      try {
        sessionStorage.removeItem("notificationsViewed");
      } catch (e) {
        // sessionStorage might not be available
      }
    }
    prevHasNotificationRef.current = hasNotification;
  }, [hasNotification]);

  // Mark notifications as viewed when dropdown opens
  React.useEffect(() => {
    if (isNotificationOpen && hasNotification && !notificationsViewed) {
      setNotificationsViewed(true);
      try {
        sessionStorage.setItem("notificationsViewed", "true");
      } catch (e) {
        // sessionStorage might not be available
      }
    }
  }, [isNotificationOpen, hasNotification, notificationsViewed]);

  const handleAvatarClick = () => {
    setIsOpen((val) => !val);
  };
  const handleUserMenuClose = () => {
    setIsOpen(false);
  };
  const handleNotificationClick = () => {
    setIsNotificationOpen((val) => !val);
  };
  const handleNotificationClose = () => {
    setIsNotificationOpen(false);
  };
  const handleSupportOpen = () => setIsSupportOpen(true);
  const handleSupportClose = () => setIsSupportOpen(false);
  /**
   * Extracts the year from a period string.
   */
  const extractYearFromPeriod = (periodName: string): string | null => {
    if (!periodName) return null;
    const yearMatch = periodName.match(/\/(\s*)(\d{4})/);
    if (yearMatch) return yearMatch[2];
    const yearAtEnd = periodName.match(/(20\d{2})$/);
    if (yearAtEnd) return yearAtEnd[1];
    return null;
  };

  const handleTaskClick = (task: ICardElementWithChildren) => {
    // Determine target model ID based on task period
    const taskPeriod = task.workflowState?.period;
    let targetModelId = ctx.modelId;
    if (taskPeriod) {
      const taskYear = extractYearFromPeriod(taskPeriod);
      const mappedModelId = taskYear && getModelIdForYear(taskYear);
      if (mappedModelId) {
        targetModelId = mappedModelId;
      }
    }

    // Update context model if needed
    if (targetModelId !== ctx.modelId) {
      ctx.sendValue("modelId", targetModelId);
    }

    if (task.workflowState?.wfShortType === "value") {
      link({
        page: "workflowinput",
        meaId: task.workflowState?.measureId || task.workflowState?.wfInstanceId,
        period: taskPeriod,
        model: targetModelId, // Always use the model ID based on task period
      });
    } else if (task.workflowState?.wfShortType === "create") {
      link({
        page:
          task.workflowState?.measureType === "KPI"
            ? "kpisform"
            : "projectsform",
        wf: task.workflowState?.wfInstanceId,
        model: targetModelId, // Always use the model ID based on task period
      });
    } else if (task.workflowState?.wfShortType === "delete") {
      link({
        page:
          task.workflowState?.measureType === "KPI"
            ? "kpisform"
            : "projectsform",
        wf: task.workflowState?.wfInstanceId,
        type: "del",
        model: targetModelId, // Always use the model ID based on task period
      });
    } else if (task.workflowState?.wfShortType === "modify") {
      link({
        page:
          task.workflowState?.measureType === "KPI"
            ? "kpisform"
            : "projectsform",
        wf: task.workflowState?.wfInstanceId,
        type: "new",
        model: targetModelId, // Always use the model ID based on task period
      });
    }
  };
  const handleLogOutClick = async () => {
    handleUserMenuClose();
    const isLoggedOut = await logout();
    // @ts-ignore
    if (isLoggedOut) {
      await queryClient.invalidateQueries();
      clearElementCache();
      localStorage.removeItem("SelectedReport");
      // Clear notifications viewed state on logout
      try {
        sessionStorage.removeItem("notificationsViewed");
      } catch (e) {
        // sessionStorage might not be available
      }
      history.push(`/${tenant.symbol}/`);
    }
  };
  // (legacy) kept for compatibility with older appbar variants
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const PlanSwitchButton = registry.getSvgIcon("PlanSwitchButton");

  return (
    <AppBar>
      <ApplicationToolBar style={{ height: "70px" }}>
        <div className={classes.appBarLeftSide}>
          <HorizontalMenu tenant={tenant.symbol} />
          {/* Always show home icon for all users to navigate back to home page */}
          {!pathname.includes("landingpage") && (
            <IconButton 
              className={classes.iconButton} 
              title={t("Home")}
              onClick={() => {
                // CEO view: Home always resets the KPIs page Division and KPI Status
                // filters back to "All" rather than leaving previous selections cached.
                if (isCeoOnlyUser) {
                  const modelIdForFilters = ctx.modelId || modelIdFromUrl || "";
                  if (modelIdForFilters) {
                    persistKpisFilters(buildKpisFilterStorageKey(modelIdForFilters), {
                      selectedL1: "all",
                      statusFilter: "all",
                    });
                  }
                }
                history.push(`/${ctx.tenant || tenant.symbol}/`);
              }}
              style={{ display: "flex", alignItems: "center" }}
            >
              <HomeIcon />
            </IconButton>
          )}
          <System.Toolbar.PlanSwitch />
          <System.Toolbar.Breadcrumb />
        </div>
        <Flex>
          {!pathname.includes("landingpage") && ctx.modelId && (
            <div className={clsx(classes.planContainer)}>
              <p className={classes.planText}>{t(ctx.modelId || "")}</p>
            </div>
          )}

          <System.Toolbar.SearchBar />

          <Button
            className={classes.supportButton}
            onClick={handleSupportOpen}
            variant="text"
          >
            {t("Support")}
          </Button>

          {!isCeoOnlyUser && (
            <div ref={notificationAnchorEl}>
              <IconButton
                className={classes.iconButton}
                onClick={handleNotificationClick}
                aria-controls="notification-menu"
                aria-haspopup
              >
                <Badge
                  color="secondary"
                  badgeContent={notificationCount > 0 ? notificationCount : undefined}
                  overlap="circular"
                  invisible={!hasNotification || notificationCount === 0 || isNotificationOpen || notificationsViewed}
                >
                  {System.icons.NotificationIcon}
                  {/*
            <img src={getFileApiURL('/icons/TECNotificationCenter.svg')} alt="Notifications" />
          */}
                </Badge>
              </IconButton>
              {isNotificationOpen && (
                <NotificationDropdown
                  parentRef={notificationAnchorEl.current}
                  onClose={handleNotificationClose}
                  onTaskClick={handleTaskClick}
                  tasks={(filteredTasks || []) as ICardElementWithChildren[]}
                  isLoading={isLoading}
                />
              )}
            </div>
          )}
          <div ref={userMenuAnchorEl}>
            <IconButton
              className={classes.avatarButton}
              aria-controls="user-menu"
              aria-haspopup
              onClick={handleAvatarClick}
            >
              <Avatar className={classes.avatarIcon}>
                <PersonOutlineOutlined fontSize="large" />
              </Avatar>
              <DownIcon fontSize="large" />
            </IconButton>
            {isOpen && (
              <UserMenuCard
                tenant={tenant}
                parentRef={userMenuAnchorEl.current}
                logout={handleLogOutClick}
                onClose={handleUserMenuClose}
                user={user}
              />
            )}
          </div>
          {System.icons.AppBarImage}
        </Flex>
      </ApplicationToolBar>

      <Dialog
        open={isSupportOpen}
        onClose={handleSupportClose}
        aria-labelledby="support-dialog-title"
        maxWidth="md"
        fullWidth
        classes={{ paper: classes.supportDialogPaper }}
      >
        <DialogTitle
          id="support-dialog-title"
          disableTypography
          className={classes.supportDialogTitle}
        >
          <Typography className={classes.supportDialogTitleText}>
            {t("Support")}
          </Typography>
          <Typography className={classes.supportDialogSubtitle}>
            {t("You can contact us via email or Microsoft Teams.")}
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.supportDialogContent}>
          <Card variant="outlined" className={classes.supportInfoCard}>
            <CardContent className={classes.supportInfoCardContent}>
              <Typography className={classes.supportLabel}>
                {t("Support email")}
              </Typography>
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className={classes.supportEmailLink}
              >
                {SUPPORT_EMAIL}
              </a>
              <a
                href={`mailto:${SUPPORT_EMAIL_CPP}`}
                className={classes.supportEmailLink}
                style={{ display: "block", marginTop: 8 }}
              >
                {SUPPORT_EMAIL_CPP}
              </a>
              <Divider style={{ marginTop: 14, marginBottom: 12 }} />
              <Typography className={classes.supportHint}>
                {t(
                  "If you face any issues, please reach out by email or Microsoft Teams and we will assist you."
                )}
              </Typography>

              <Box className={classes.supportTeamsRow}>
                <Box className={classes.supportTeamsColumn}>
                  <Typography className={classes.supportContactName} component="p">
                    Abdulrahman Alajlan
                  </Typography>
                  <Button
                    className={classes.supportTeamsButton}
                    color="primary"
                    variant="outlined"
                    component="a"
                    href={supportTeamsChatUrl(SUPPORT_TEAMS_ABDULRAHMAN_UPN)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Chat on Teams")}
                  </Button>
                </Box>
                <Box className={classes.supportTeamsColumn}>
                  <Typography className={classes.supportContactName} component="p">
                    Ahmed Alsaiqal
                  </Typography>
                  <Button
                    className={classes.supportTeamsButton}
                    color="primary"
                    variant="outlined"
                    component="a"
                    href={supportTeamsChatUrl(SUPPORT_TEAMS_AHMED_UPN)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Chat on Teams")}
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSupportClose} color="primary" variant="contained">
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  );
};
export default BusinessPortalAppBar;
